import * as React from 'react';
import { mediaMobileOnly, mediaTablet } from '../../theme/media';
import { classes, style } from 'typestyle';
import { colorSlate, colorWhite } from '../../theme/color';
import { em, px } from 'csx';
import { observer } from 'mobx-react';
import { fontHeading } from '../../theme/font';
import { constantTileCarouselDesktopSize, constantTileCarouselMobileSize } from '../../theme/constant';

export interface TitledCarouselProps {
  hasBackground?: boolean;
  onClickLink?: (event: React.MouseEvent<any>) => void;
  i18n?: {
    title: string;
  };
  href?: string;
}

const DEFAULT_I18N = {
  title: 'Ending soon',
};

export const TitledCarousel = observer<TitledCarouselProps>(
  ({ children, hasBackground, onClickLink, i18n = DEFAULT_I18N, href }) => (
    <div
      className={classes(
        styles.container,
        hasBackground ? styles.containerWithBackground : styles.containerNoBackground,
      )}
    >
      <div className={styles.titleWrapper}>
        <span className={styles.heading}>{i18n.title}</span>
        {href && (
          <a className={styles.headingLink} href={href} onClick={onClickLink}>
            View all
          </a>
        )}
      </div>
      {children}
    </div>
  ),
);

const styles = {
  container: style({
    position: 'relative',
    margin: '40px 0 0 0',
  }),
  containerNoBackground: style({
    color: colorSlate.toString(),
  }),
  containerWithBackground: style({
    color: colorWhite.toString(),
    $nest: {
      '& a': {
        color: colorWhite.toString(),
      },
    },
  }),
  titleWrapper: style(
    {
      display: 'flex',
      justifyContent: 'space-between',
    },
    mediaMobileOnly({
      width: constantTileCarouselMobileSize,
      marginLeft: px(20),
    }),
    mediaTablet({
      width: constantTileCarouselDesktopSize,
      marginLeft: px(40),
    }),
  ),
  heading: style({
    margin: '0 0 20px 0',
    fontSize: px(20),
    fontWeight: 500,
    fontFamily: fontHeading,
    letterSpacing: em(-0.0625),
    display: 'inline-block',
  }),
  headingLink: style({
    textDecoration: 'underline',
  }),
};
